<div class="polpo-loading" @fadeIn>
  <campus-lottie lottieKey="loading"></campus-lottie>
</div>
